import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import ProgressInfluencerModal from '@common/influencer-search/_modal';
import RegisterModal           from '@common/influencer-search/register/register-modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProgressAdditionInfluencer extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      select_modal   : false,
      addition_modal : false,
      addition_mode  : '',
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ select_modal: flg });
  }
  // -------------------------------------------------------
  
  additionSelect(flg, addition_mode) {
    this.setState({ addition_modal: flg, addition_mode: addition_mode, select_modal: false });
    
    if( this.state.addition_mode == 'register' && flg == false ) this.props.base.event.refreshWorkflow.bind(this)();
  }
  // -------------------------------------------------------
  
  selectInfluencer(insta_user_id, progress) {
    
    // メンバー設定
    let members = this.props.base.multi_select;
    if( members == undefined ) members = [];
    
    if( members.indexOf(insta_user_id) == -1 ) members.push(insta_user_id);
    
    Utils.request.bind(this)('/api/project/workflow/addition_influencer', { members: members, project_id: this.props.base.project.id, progress: progress },
      function(res){
        this.props.base.event.updateData('workflow', res.body.workflow);
        this.props.base.event.updateData.bind(this)('multi_select', []);
        this.props.base.event.updateData.bind(this)('multi_select_mode', '');
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let base = Object.assign({}, this.props.base)
    
    let set_base = Object.assign(base, {
      mode     : 'workflow',
      workflow : base.workflow,
      select_influencer : base.workflow.influencers,
    });
    
    set_base.event.select_ev = this.selectInfluencer.bind(this);
    
    return (
      <div className="progress-addition-influencer">
        <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>インフルエンサーの追加</Tooltip>}>
          { (this.props.button != undefined) ? React.cloneElement(this.props.button, { onClick: this.toggleModal.bind(this, true) }) : <p className="plus-mark" onClick={this.toggleModal.bind(this, true)}>＋</p> }
        </OverlayTrigger>
        
  	    <AdditionSelectModal base={set_base} view={this.state.select_modal} close_ev={this.toggleModal.bind(this)} select_ev={this.additionSelect.bind(this)} />
  	    
  	    { (this.state.addition_mode == 'search' ) &&
  	      <ProgressInfluencerModal base={set_base} view={this.state.addition_modal} close_ev={this.additionSelect.bind(this)} />
  	    }
  	    
  	    { (this.state.addition_mode == 'register' ) && 
  	      <div className="influencer-search-common">
  	        <RegisterModal view={this.state.addition_modal} register_mode="workflow" project={base.project} close_ev={this.additionSelect.bind(this)} /> }
  	      </div>
  	    }
      </div>
    );
  }
}
// -------------------------------------------------------

class AdditionSelectModal extends React.Component {
  render() {
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {400}
        height    = {250}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {
          <div className="modal-item project-addition-select-modal">
            <h2>追加する方法を選択</h2>
            
            <div className="addition-select-modal-multi">
              <div className="add-item" onClick={this.props.select_ev.bind(this, true, 'search')}>
                <p className="material-icons">person_search</p>
                <h2>検索して登録</h2>
              </div>
              <div className="add-item" onClick={this.props.select_ev.bind(this, true, 'register')}>
                <p className="material-icons">switch_account</p>
                <h2>まとめて登録</h2>
              </div>
            </div>
          </div>
        }
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProgressAdditionInfluencer;